import { useState, useCallback, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'
import { ENTITY_TYPES } from '@sales-center/common'
import {
  updateReferral as updateLeadReferral,
  updateReferralIdOnCard,
} from '@user/store/lead'
import {
  updateOppReferralIdOnCard,
  updateReferral as updateOpportunityReferral,
} from '@user/store/opportunity'
import { UpdateReferralInput } from './typing'
export const useUpdateReferral = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const [toUpdate, setToUpdate] = useState<UpdateReferralInput>()

  const execute = useCallback(
    (refferalInput: UpdateReferralInput) => {
      if (status != 'pending') {
        setToUpdate(refferalInput)
      }
    },
    [status],
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (toUpdate) {
        try {
          setStatus('pending')
          if (toUpdate.entityType === ENTITY_TYPES.Lead) {
            const response = await dispatch(
              updateLeadReferral({
                entityId: toUpdate.entityId,
                referral: toUpdate.referral,
              }),
            )

            if (updateLeadReferral.fulfilled.match(response)) {
              dispatch(
                updateReferralIdOnCard({
                  leadId: toUpdate.entityId,
                  referralDiscountId: toUpdate.referral?.referralDiscountId,
                }),
              )
              setStatus('success')
            } else {
              setStatus('fail')
              toast.error(`Unable to update lead next action date.`)
            }
          }
          if (toUpdate.entityType === ENTITY_TYPES.Opportunity) {
            const response = await dispatch(
              updateOpportunityReferral({
                entityId: toUpdate.entityId,
                referral: toUpdate.referral,
              }),
            )
            if (updateOpportunityReferral.fulfilled.match(response)) {
              dispatch(
                updateOppReferralIdOnCard({
                  opportunityId: toUpdate.entityId,
                  referralDiscountId: toUpdate.referral?.referralDiscountId,
                }),
              )
              setStatus('success')
            } else {
              setStatus('fail')
              toast.error(`Unable to update lead next action date.`)
            }
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
            toast.error(error.Message)
          }
        } finally {
          setToUpdate(undefined)
          setStatus('idle')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, toUpdate])

  return { status, execute }
}
